import { useState } from 'react';
import { EnvelopeIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/solid';

export default function HelpPage() {
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const mailtoLink = `mailto:info@givetechtotheblind.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(`Name: ${formData.fullName}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`)}`;
        window.location.href = mailtoLink;
    };

    return (
        <div className="bg-gray-50 dark:bg-gray-900">
            <header className="bg-white dark:bg-gray-800 py-16 text-center">
                <div className="container mx-auto px-4">
                    <QuestionMarkCircleIcon className="w-16 h-16 mx-auto text-orange-500" />
                    <h1 className="mt-4 text-4xl md:text-5xl font-extrabold text-gray-900 dark:text-white">Help Center</h1>
                    <p className="mt-4 text-xl text-gray-500 dark:text-gray-400 max-w-3xl mx-auto">
                        Have a question or need assistance? We're here to help.
                    </p>
                </div>
            </header>

            <main className="container mx-auto px-4 py-20">
                <div className="max-w-2xl mx-auto bg-white dark:bg-gray-800 p-8 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Send Us a Message</h2>
                    <p className="mt-1 text-gray-600 dark:text-gray-400">Your message will be sent to our support team at info@givetechtotheblind.com.</p>
                    <form onSubmit={handleSubmit} className="mt-6 space-y-6">
                        <input type="text" name="fullName" placeholder="Your Full Name" value={formData.fullName} onChange={handleChange} required className="w-full p-3 border rounded-lg" />
                        <input type="email" name="email" placeholder="Your Email Address" value={formData.email} onChange={handleChange} required className="w-full p-3 border rounded-lg" />
                        <input type="text" name="subject" placeholder="Subject" value={formData.subject} onChange={handleChange} required className="w-full p-3 border rounded-lg" />
                        <textarea name="message" placeholder="How can we help you?" value={formData.message} onChange={handleChange} required rows="5" className="w-full p-3 border rounded-lg" />
                        <button type="submit" className="w-full py-3 bg-orange-500 text-white font-bold rounded-lg hover:bg-orange-600">
                            Send Message
                        </button>
                    </form>
                </div>
            </main>
        </div>
    );
}